module.exports = __webpack_public_path__ + "assets/img/citizen-card.b84b9c68.jpg";